import '@strapi/icons';
export { m as default } from './chunks/index-DBUaMD56.mjs';
import 'react/jsx-runtime';
import 'react';
import '@strapi/admin/strapi-admin';
import '@strapi/design-system';
import 'formik';
import 'react-intl';
import '@strapi/content-manager/strapi-admin';
import '@strapi/icons/symbols';
import 'react-router-dom';
import 'yup';
import 'styled-components';
//# sourceMappingURL=index.mjs.map
